<template>
  <section class="ProposalEmbedSection">
    <h2>Mountain Lion Hunting Proposal (Pages 26-31)</h2>
    <iframe v-if="showPdf"
      :src="pdfUrl"
      width="100%"
      height="900"
      style="border:none"
      title="Mountain Lion Hunting Proposal PDF"
    ></iframe>
   
  </section>
</template>

<script>
export default {
  name: "ProposalEmbedSection",
  data() {
    return {
          showPdf: false,
      pdfUrl: "/JulyCommissionMeeting.pdf#page=26",
      fullPdfUrl: "/JulyCommissionMeeting.pdf",
    };
  },
  mounted() {
  setTimeout(() => {
    this.showPdf = true;
        window.scrollTo({ top: 0, behavior: "smooth" });
  }, 1000); 
}
};
</script>

<style scoped>
.ProposalEmbedSection {
  padding: 24px;
}
</style>
